
import React, { useEffect, useState } from 'react';
import { Box, TextField, Select, MenuItem, FormControlLabel, Checkbox, TextareaAutosize, Button, Tooltip, FormControl, InputLabel, FormGroup, Radio, Grid } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import axios from "../../../utils/fvAxios";
import $ from 'jquery';
import fileDownload from "js-file-download";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

export default function EmployeeCousre({ handleClose1, data,clearCaches,refes,setRes }) {
  const QuestionTypes = {
    Label: 1,
    Text: 2,
    Number: 3,
    TextArea: 4,
    Email: 5,
    Radio: 7,
    CheckBox: 8,
    DropDown: 9,
    MultiSelect: 10,
    Date: 11,
    Button: 12,
  };


  const [formValues, setFormValues] = useState({});
  const [errorMessages, setErrorMessages] = useState({});
  const [filesdownloader, setfilesdownloader] = useState(null);
  const [loader, setloader] = useState(true);
  const [delay, setdelay] = useState(true);


 

  useEffect(() => {
  
 console.log(filesdownloader);
 setfilesdownloader(null)
  }, [clearCaches]);

  useEffect(() => {
 
    if (data?.moodleQuizDetailsId != undefined) {
      axios
        .get("Documents/DownloadMoodleDocument?moodleDocId=" + data?.moodleQuizDetailsId,
          {
            responseType: 'blob',
          }
        )
        .then((res) => {
          setfilesdownloader(res?.data);


        }).finally(()=>{
          setloader(false)
          setTimeout(() => {
            setdelay(false)
          }, 4000);
        })
    }
  }, [data]);

  const handleInputChange = (field, value) => {
    debugger;
    setFormValues((prevValues) => ({
      ...prevValues,
      [field]: value,
    }));
  };

  const handleFormSubmit = () => {
    const mandatoryQuestions = data?.questionsSpecificToTraining?.filter((question) => question.isMandatory);
    const areAllMandatoryQuestionsFilled = mandatoryQuestions.every((question) => {
      const { trainingQuestionText } = question;
      const value = formValues[trainingQuestionText];
      return value !== undefined && value !== '';
    });

    if (!areAllMandatoryQuestionsFilled) {
      // Alert if mandatory questions are not filled
      alert('Please fill in all mandatory questions.');
    } else {
      const requestData = {
        employeeId: Number(data.employeeId),
        courseId: Number(data.courseId),
        launch: data.launch.toString(),
        scormid: data.scormid.toString(),
        fieldsWithValues: '',
      };

      for (const question of data?.questionsSpecificToTraining || []) {
        const { trainingQuestionColumnDetails, trainingQuestionText } = question;

        if (Array.isArray(trainingQuestionColumnDetails) && trainingQuestionColumnDetails.length > 0) {
          for (const columnDetail of trainingQuestionColumnDetails) {
            const { questionControlTypeId } = columnDetail;
            const trainingQuestionColumnId = columnDetail.trainingQuestionColumnId;

            if (questionControlTypeId === QuestionTypes.CheckBox || questionControlTypeId === QuestionTypes.MultiSelect) {
              const checkedOptions = formValues[trainingQuestionText] || [];
              for (const option of checkedOptions) {
                if (requestData.fieldsWithValues !== '') {
                  requestData.fieldsWithValues += ',';
                }
                requestData.fieldsWithValues += `${trainingQuestionColumnId}^${option}`;
              }
            } else if (questionControlTypeId === QuestionTypes.DropDown) {
              const selectedOptions = formValues[trainingQuestionText] || [];
              for (const option of selectedOptions) {
                if (requestData.fieldsWithValues !== '') {
                  requestData.fieldsWithValues += ',';
                }
                requestData.fieldsWithValues += `${trainingQuestionColumnId}^${option}`;
              }
            } else if (questionControlTypeId === QuestionTypes.Radio) {
              const value = formValues[trainingQuestionText];

              if (value !== undefined && value !== '') {
                const columnValuesArray = columnDetail.columnValues.split('|');
                const index = columnValuesArray.indexOf(value);

                if (index !== -1) {
                  if (requestData.fieldsWithValues !== '') {
                    requestData.fieldsWithValues += ',';
                  }
                  requestData.fieldsWithValues += `${trainingQuestionColumnId}^${value}`;
                }
              }
            } else {
              const value = formValues[trainingQuestionText];

              if (value !== undefined && value !== '') {
                if (requestData.fieldsWithValues !== '') {
                  requestData.fieldsWithValues += ',';
                }
                requestData.fieldsWithValues += `${trainingQuestionColumnId}^${value}`;
              }
            }
          }
        }
      }

    
      axios.post('Employee/SaveEmployeeInput', requestData, {
        headers: { "Content-Type": "application/json" },
      })
        .then(res => {
          var myWindow = window.open(res?.data?.data, "myWindow", 'width=800,height=600');

          handleClose1()
          var pollTimer = window.setInterval(function () {
            if (myWindow.closed !== false) {
              window.clearInterval(pollTimer);

              setRes(!refes);
             
            }
          }, 1000);
        })
        .catch(error => {
  
          console.error('Error:', error);
        });
    }
  };

  const renderFormField = (question) => {
    const { trainingQuestionText, isMandatory, correctAnswer } = question;


    if (
      Array.isArray(question.trainingQuestionColumnDetails) &&
      question.trainingQuestionColumnDetails.length > 0
    ) {
      return question.trainingQuestionColumnDetails.map((columnDetail) => {
        const { questionControlTypeId, columnValues, displayType } = columnDetail;

        if (questionControlTypeId === undefined) {
          return null;
        }
        const starElement = isMandatory ? <span style={{ color: 'red' }}>*</span> : null;
        switch (questionControlTypeId) {
          case QuestionTypes.Label:
            return <div key={trainingQuestionText}>{trainingQuestionText}</div>;

          case QuestionTypes.Text:
            return (
              <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} >
                <Grid item xs={12} sm={6} md={6}>
                  {trainingQuestionText}{starElement}
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <TextField
                    key={trainingQuestionText}
                    label={trainingQuestionText}
                    value={formValues[trainingQuestionText] || ''}
                    onChange={(e) => handleInputChange(trainingQuestionText, e.target.value)}
                  />
                </Grid>
              </Grid>
            );

          case QuestionTypes.Number:
            return (
              <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} >
                <Grid item xs={12} sm={6} md={6}>
                  {trainingQuestionText}{starElement}
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <TextField
                    key={trainingQuestionText}
                    label={trainingQuestionText}
                    type="number"
                    value={formValues[trainingQuestionText] || ''}
                    onChange={(e) => handleInputChange(trainingQuestionText, e.target.value)}
                  />
                </Grid>
              </Grid>
            );

          case QuestionTypes.Email:
            return (
              <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} >
                <Grid item xs={12} sm={6} md={6}>
                  {trainingQuestionText}{starElement}
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <TextField
                    key={trainingQuestionText}
                    label={trainingQuestionText}
                    type="email"
                    value={formValues[trainingQuestionText] || ''}
                    onChange={(e) => handleInputChange(trainingQuestionText, e.target.value)}
                  />
                </Grid>
              </Grid>
            );


          case QuestionTypes.TextArea:
            return (
              <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} >
                <Grid item xs={12} sm={6} md={6}>
                  {trainingQuestionText}{starElement}
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <TextareaAutosize
                    key={trainingQuestionText}
                    rowsMin={3}
                    placeholder={trainingQuestionText}
                    value={formValues[trainingQuestionText] || ''}
                    onChange={(e) => handleInputChange(trainingQuestionText, e.target.value)}
                  />
                </Grid>
              </Grid>
            );

          case QuestionTypes.Radio:
            return (
              <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} >
                <Grid item xs={12} sm={6} md={6}>
                  {trainingQuestionText}{starElement}
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <FormControl key={trainingQuestionText} component="fieldset">
                    <FormGroup>

                      {
                        columnValues.split('|').map((option) => (
                          <FormControlLabel
                            key={option}
                            control={<Radio />}
                            label={option}
                            value={option}
                            checked={formValues[trainingQuestionText] === option}
                            onChange={() => handleInputChange(trainingQuestionText, option)}
                          />
                        ))
                      }

                    </FormGroup>
                  </FormControl>
                </Grid>
              </Grid>
            );

          case QuestionTypes.CheckBox:
            return (
              <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} >
                <Grid item xs={12} sm={6} md={6}>
                  {trainingQuestionText}{starElement}
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <FormControl key={trainingQuestionText} component="fieldset">
                    <FormGroup>

                      {
                        columnValues.split('|').map((option, index) => (
                          <FormControlLabel
                            key={option}
                            control={<Radio />}
                            label={option}
                            value={index === 0 ? 'true' : 'false'}
                            checked={formValues[trainingQuestionText] === (index === 0 ? 'true' : 'false')}
                            onChange={() => handleInputChange(trainingQuestionText, index === 0 ? 'true' : 'false')}
                          />
                        ))
                      }

                    </FormGroup>
                  </FormControl>
                </Grid>
              </Grid>
            );

          case QuestionTypes.DropDown:
            return (
              <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} >
                <Grid item xs={12} sm={6} md={6}>
                  {trainingQuestionText}
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <FormControl key={trainingQuestionText}>
                    <InputLabel id={`${trainingQuestionText}-label`}>{trainingQuestionText}</InputLabel>
                    <Select
                      labelId={`${trainingQuestionText}-label`}
                      value={formValues[trainingQuestionText] || ''}
                      onChange={(e) => handleInputChange(trainingQuestionText, e.target.value)}
                    >

                      {columnValues.split('|').map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            );

          case QuestionTypes.MultiSelect:
            return (
              <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} >
                <Grid item xs={12} sm={6} md={6}>
                  {trainingQuestionText}
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <FormControl key={trainingQuestionText}>
                    <InputLabel id={`${trainingQuestionText}-label`}>{trainingQuestionText}</InputLabel>
                    <Select
                      labelId={`${trainingQuestionText}-label`}
                      multiple
                      value={formValues[trainingQuestionText] || []}
                      onChange={(e) => handleInputChange(trainingQuestionText, e.target.value)}
                    >

                      {columnValues.split('|').map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            );

          case QuestionTypes.Date:
            return (
              <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} >
                <Grid item xs={12} sm={6} md={6}>
                  {trainingQuestionText}
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <LocalizationProvider key={trainingQuestionText} dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label={trainingQuestionText}
                      value={formValues[trainingQuestionText] || null}
                      onChange={(date) => handleInputChange(trainingQuestionText, date)}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </LocalizationProvider>
                </Grid>
              </Grid>
            );

          default:
            return null;
        }
      });
    }

    return null;
  };
  const [showFileDownloader, setShowFileDownloader] = useState(true);

  const handleProceedClick = () => {
    setShowFileDownloader(false);
  };
 
  return (
    <>
      <AppBar sx={{ position: "fixed", backgroundColor: "#1976d2" }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={() => { handleClose1(); setShowFileDownloader(true); }}
            aria-label="close"
            sx={{ color: "#fff" }}
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>





      <Box style={{ padding: "20px", marginTop: "100px" }}>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loader||delay}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      {showFileDownloader ? (
        <div>
          {filesdownloader && (
<div hidden={delay}>
            <iframe
              title="Downloaded File"
              src={URL.createObjectURL(filesdownloader)}
              width="100%"
              height="800px"
            />
            </div>
          )}
          <br />
          <Button
            variant="contained"
            color="primary"
            style={{ padding: "20px" }}
            onClick={handleProceedClick}
          >
            Proceed To Acknowledgement
          </Button>
        </div>
      ) : (
        <div>
          <div dangerouslySetInnerHTML={{ __html: data?.headerContent }} />
          <br />
          {data?.questionsSpecificToTraining?.map((question) =>
            renderFormField(question)
          )}
          <br />
          <Button variant="contained" color="primary" onClick={handleFormSubmit}    style={{ padding: "20px" }}>
            Submit
          </Button>
        </div>
      )}
    </Box>
    </>
  )
}
